module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-6 q-marg-bottom-md-at-md\"> <div class=\"quick-btn-group qb-default qb-purple-theme q-text-center date-range-type-toggler\"> {%=options%} <input type=hidden class=quick-btn-group-hidden-input id=\"{%-key%}\" name=\"{%-key%}\" value=\"{%-value%}\"/> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/report/lookup/html/dateRangeTypeParam.html
// module id = 1399
// module chunks = 1